<template>

    <div class="page">
        <SidebarBody/>
        <OmmpBody/>
    </div>
    
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import SidebarBody from "@/components/dashboard/SidebarBody.vue";
  import OmmpBody from "@/components/dashboard/OmmpBody.vue";
  
  export default defineComponent({
    name: "OmmpView",
    components: {
      SidebarBody,
      OmmpBody
    },
  });
  </script>
  